type NumericDomain = [number, number];

export type LinearScale = (value: number) => number;

/** Maps values from a numeric domain to a numeric range with a linear interpolation. */
export function createLinearScale(domain: NumericDomain, range: NumericDomain): LinearScale {
  const [domainStart, domainEnd] = domain;
  const [rangeStart, rangeEnd] = range;
  const domainLength = domainEnd - domainStart;

  if (domainLength === 0) {
    const rangeMidpoint = rangeStart + (rangeEnd - rangeStart) / 2;
    return () => rangeMidpoint;
  }

  const rangeLength = rangeEnd - rangeStart;
  return (value) => rangeStart + ((value - domainStart) / domainLength) * rangeLength;
}

/** Maps a value from a linear scale's range back to its domain. */
export const invertLinearScale = (value: number, domain: NumericDomain, range: NumericDomain) =>
  createLinearScale(range, domain)(value);
